import React, { useEffect, useState } from "react";
import { Button, ModalHeader, ModalBody, ModalFooter, Modal } from "reactstrap";
import moment from "moment";
import { connect } from "react-redux";
import { fetchItemOffers, fetchItemOffersSuccess, fetchItemOffersFailure } from "../../store/inventories/actions";

const ItemPriceOptions = ({ onSubmit, itemAndPo, closeModal, fetchItemOffers, offers, handleChangeItem, onOfferChange }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => {
    fetchItemOffers(itemAndPo.item.item);
  }, []);

  const handleChange = () => {
    if (itemAndPo.purchaseOrder.vendor.id !== selectedItem.vendor_id) {
      handleChangeItem(selectedItem, itemAndPo.item, itemAndPo.purchaseOrder);
      closeModal();
    }
  };

  return (
    <Modal
      isOpen={itemAndPo.item}
      toggle={() => closeModal(false)}
      className={"modal-warning modal-logut"}
      size="lg"
      style={{ maxWidth: "900px", width: "100%" }}
    >
      <ModalHeader toggle={() => closeModal(false)}>Latest prices for {itemAndPo.item.name}</ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-sm-12" style={{ marginBottom: "15px" }}>
            <span>Compare the price of your selected item and select the best option</span>
          </div>
        </div>
        <table className="table table-striped table-order-station datatable mb-0">
          <thead className="thead-inverse">
            <tr>
              <th>List date</th>
              <th>Vendor</th>
              <th>Brand</th>
              <th>Price</th>
              <th>Normalized price</th>
              <th>Pack</th>
              <th>Unit</th>
              <th>Selected</th>
            </tr>
          </thead>
          {offers.map((offer, index) => (
            <tbody>
              <tr
                className={itemAndPo.purchaseOrder.vendor.id === offer.vendor_id && "offer-row table-info"}
                key={index}
                onClick={() => itemAndPo.purchaseOrder.vendor.id !== offer.vendor_id && setSelectedItem(offer)}
              >
                <td>{offer ? moment(offer.offer_list_date).utc().format("L") : ""}</td>
                <td>{offer.vendor_name}</td>
                <td>{offer.brand}</td>
                <td>{offer.price}</td>
                <td>{offer.normalized_price}</td>
                <td>{offer.items_per_pack}</td>
                <td>{offer.unit}</td>
                <td>
                  {itemAndPo.purchaseOrder.vendor.id !== offer.vendor_id && (
                    <input
                      style={{ marginLeft: "20px" }}
                      type="checkbox"
                      value={offer.vendor_id}
                      checked={selectedItem && offer.id === selectedItem.id}
                      onChange={onOfferChange}
                    />
                  )}
                </td>
                {itemAndPo.purchaseOrder.vendor.id === offer.vendor_id && <div className="offer-warning-detail">currently selected</div>}
              </tr>
            </tbody>
          ))}
        </table>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" disabled={!selectedItem} onClick={() => handleChange()}>
          Switch for the selected item
        </Button>
        <Button color="secondary" onClick={() => closeModal(false)}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    offers: state.inventories.offersList.offers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchItemOffers: (id) => {
      dispatch(fetchItemOffers(id)).payload.then(
        (response) => {
          dispatch(fetchItemOffersSuccess(response.data));
        },
        (error) => {
          dispatch(fetchItemOffersFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemPriceOptions);
